<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">CRM管理</Breadcrumb-item>
        <Breadcrumb-item>通话转写词表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 10px">
      <Form :label-width="85" :show-message="false">
        <Row :gutter="32">
          <Col span="6">
            <Form-item label="错词">
              <Input placeholder="错词或原词" v-model="queryParam.srcWord"/>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="状态">
              <Select v-model="queryParam.enabled" clearable placeholder="全部">
                <Option :value="1">启用</Option>
                <Option :value="0">停用</Option>
              </Select>
            </Form-item>
          </Col>
          <Col span="8">
            <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
            <Button type="success" style="margin-left: 8px" @click="openCreate">新增</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/callAsrWord/page-list"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
    <Modal v-model="editVisible" :title="form.id ? '编辑词条' : '新增词条'" width="520">
      <Form :label-width="90">
        <Form-item label="错词">
          <Input v-model="form.srcWord" placeholder="识别错了的词，如哈斯理"></Input>
        </Form-item>
        <Form-item label="正确词">
          <Input v-model="form.dstWord" placeholder="替换成的正确词，如HelloKid"></Input>
        </Form-item>
        <Form-item label="状态">
          <Select v-model="form.enabled">
            <Option :value="1">启用</Option>
            <Option :value="0">停用</Option>
          </Select>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" @click="save">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'CallAsrWord',
  data () {
    return {
      searchLoading: false,
      reload: 0,
      editVisible: false,
      queryParam: {
        srcWord: '',
        enabled: ''
      },
      form: {},
      tableColumns: [
        { title: 'ID', key: 'id', width: 80 },
        { title: '错词', key: 'srcWord', minWidth: 160 },
        { title: '正确词', key: 'dstWord', minWidth: 160 },
        {
          title: '状态',
          key: 'enabled',
          width: 90,
          render: (h, params) => h('span', params.row.enabled === 1 ? '启用' : '停用')
        },
        { title: '修改时间', key: 'gmtModified', minWidth: 170 },
        {
          title: '操作',
          key: 'action',
          width: 180,
          render: (h, params) => {
            return h('div', { style: { whiteSpace: 'nowrap' } }, [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '6px' },
                on: { click: () => this.openEdit(params.row) }
              }, '编辑'),
              h('Button', {
                props: { size: 'small' },
                on: { click: () => this.changeStatus(params.row) }
              }, params.row.enabled === 1 ? '停用' : '启用')
            ])
          }
        }
      ]
    }
  },
  methods: {
    onLoading (loading) {
      this.searchLoading = loading
    },
    emptyForm () {
      return {
        srcWord: '',
        dstWord: '',
        enabled: 1
      }
    },
    search () {
      this.reload = Date.now()
      this.$nextTick(() => this.$refs.list && this.$refs.list.search())
    },
    openCreate () {
      this.form = this.emptyForm()
      this.editVisible = true
    },
    openEdit (row) {
      this.form = {
        id: row.id,
        srcWord: row.srcWord,
        dstWord: row.dstWord,
        enabled: row.enabled
      }
      this.editVisible = true
    },
    save () {
      this.$http.post('/callAsrWord/save', this.form).then(res => {
        if (res.status === 'ok') {
          this.$Message.success(this.form.id ? '已更新' : '已新建')
          this.editVisible = false
          this.search()
        } else {
          this.$Message.error(res.msg || '保存失败')
        }
      })
    },
    changeStatus (row) {
      const enabled = row.enabled === 1 ? 0 : 1
      this.$http.post('/callAsrWord/status', { id: row.id, enabled: enabled }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success(enabled === 1 ? '已启用' : '已停用')
          this.search()
        } else {
          this.$Message.error(res.msg || '操作失败')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CallAsrWord.vue?4be19035